import React__default from 'react';
import { useDialog } from 'react-aria';
import { StyledDialog } from './styles.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 *
 * Dialog is a low-level primitive to help achieve accessible dialogs that can be styled as needed.
 *
 * A dialog is an overlay shown above other content in an application.
 *
 * A dialog consists of a container element and an optional title, and the Fuegokit Dialog primitive handles
 * exposing this to assistive technology using ARIA.
 *
 * Combine with other primitives to create modal dialogs, popovers, and other types of overlays.
 *
 */
const DialogBase = /*#__PURE__*/React__default.forwardRef(({
  title,
  children,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  const {
    dialogProps,
    titleProps
  } = useDialog(props, innerRef);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(StyledDialog, _extends({
    ref: innerRef,
    style: {
      padding: 30,
      maxWidth: 200,
      outline: 'none'
    }
  }, props, dialogProps), title && /*#__PURE__*/React__default.createElement("h3", _extends({}, titleProps, {
    style: {
      marginTop: 0
    }
  }), title), children);
});
DialogBase.displayName = 'DialogBase';

export { DialogBase };
